<script setup lang="ts">

import { Button } from 'ant-design-vue';
import { func } from 'vue-types';
import { RedoOutlined } from '@ant-design/icons-vue';

defineProps({
  refetch: func().isRequired,
});
</script>

<template>
  <Button size="small" @click="refetch">
    <template #icon>
      <RedoOutlined />
    </template>
  </Button>
</template>
